import { render, staticRenderFns } from "./IconBank.vue?vue&type=template&id=70b770c8"
import script from "./IconBank.vue?vue&type=script&lang=ts"
export * from "./IconBank.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports